import { useState, useEffect } from 'react';

const useIsMobile = () => {
  const getIsMobile = () => window.innerWidth < 991;
  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    const handleResize = () => {
      const current = getIsMobile();
      setIsMobile((prev) => {
        if (prev !== current) {
          window.location.reload(); // Reload on breakpoint switch
        }
        return current;
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
};

export default useIsMobile;
